// React
import React, { useState, useEffect, useCallback } from 'react';
import { BeatLoader } from 'react-spinners';

// Kendo
import kendo from '@progress/kendo-ui';
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Button } from '@progress/kendo-react-buttons';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { Error } from '@progress/kendo-react-labels';

// Css
import './managerMngt.css';
import styles from './managerInfo.module.css';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { checkDuplicatedId } from '../../../service/mngt/managerService';
import { getUser, isDeveloper, isManager, isAdmin } from './../../../service/authService';
import { getRgns, getDongs } from './../../../service/areaService';
import { getUsers } from '../../../service/monitor/allStatusService';


const ManagerInfo = ({ conn, rgnList, dongList, isNew, managerInfo, setManagerInfo, submitData, dataItem }) => {

  const userInfo = getUser();
  const isManager = userInfo.userTypeCode === 2002;
  const isRgnManager = userInfo.userTypeCode === 2003;

  const [loading, setLoading] = useState(false);

  // 시군구 데이터
  const [rgn, setRgn] = useState( !isDeveloper() ? rgnList.find(item => item.rgnCode === getUser().rgnCode) : { rgnCode: '', rgnTerm: '지역검색' });
  // 읍면동 데이터
  const [dong, setDong] = useState( isManager ? dongList.find(item => item.dongCode === getUser().dongCode) : { dongCode: '', dongTerm: '지역검색' });
  const [userId, setUserId] = useState({
    value: '',
    check: false,
  });

  const [dataState, setDataState] = useState({
    // 드롭다운 시군구 표출 값
    rgnCode: userInfo.rgnCode,
    rgnTermSimple: null,
    rgns : { rgnTermSimple: "시/군/구", rgnCode: "" },
    // 드롭다운 읍면동 표출 값
    dongCode: userInfo.dongCode,
    dongTermSimple: null,
    dongs : { dongTermSimple: "읍/면/동", dongCode: "" },
    // 드롭다운 유저 표출 값
    userId: '',
    userTerm: '',
    users : { userTerm: "대상자 선택", userId: "" },
  });

  const defualtValRgn = { rgnTermSimple: "시/군/구", rgnCode: "" };
  const defualtValDong = { dongTermSimple: "읍/면/동", dongCode: "" };
  const defaultValUser = { userTerm: "대상자 선택", userId: "" };

  const [dataSource, setDataSource] = useState({
    rgnList: [], 
    dongList: [],
    userList: [],
  });

  // 닫기 이벤트
  const closeEvt = () => {
    setManagerInfo(managerInfo => {
      const item = { ...managerInfo };
      item.visible = !managerInfo.visible;
      item.dataItem = {};
      item.isNew = false;
      return item;
    });
  };
  // 초기 데이터 가져오기
  const getDataList = () => {
    setLoading(true);
    // 시군구
    getRgns(conn)
    .then(response => {
      setDataState(dataState => {
        const item = { ...dataState };
        item.rgns = response.find(item => item.rgnCode === userInfo.rgnCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.rgnList = response
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getRgns error = ", error);
    });
    // 읍면동
    getDongs(conn, userInfo.rgnCode)
    .then(response => {
      setDataState(dataState => {
        const item = { ...dataState };
        item.dongs = response.find(item => item.dongCode === userInfo.dongCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.dongList = response;
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getDongs error = ", error);
    });
    // 대상자
    getUsers(conn, dataState)
    .then(response => {
      setDataSource(dataSource => {
        const item = { ...dataSource };
        // item.userList = response;
        item.userList = response.filter(item => item.meainStatCode !== "20005");
        return item;
      })
    })
    .catch(error => {
      console.log("getUserList error = ", error);
    })
  }

  // ****  Validation
  // phone
  const telePhoneRegex = new RegExp(/^\d{3}-\d{3,4}-\d{4}$/);
  const telePhoneValidator = useCallback(value => (telePhoneRegex.test(value) ? '' : ' '));
  const PhoneInput = useCallback(fieldRenderProps => {
    const { validationMessage, visited, ...others } = fieldRenderProps;
    return (
      <div>
        <Input {...others} />
        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    );
  });

  // *** 담당 시군구
  const rgnComponent = formRenderProps => {
    if ((!formRenderProps.value && isManager) || (!formRenderProps.value && isRgnManager)) {
      formRenderProps.onChange({ value: userInfo.rgnCode });
    }
    const handleChange = e => {
      setDataState(dataState => {
        const item = { ...dataState };
        // 드롭다운 검색조건 변경
        item.rgnCode = e.target.value.rgnCode;
        item.rgns = e.target.value;
        // 하위 데이터 초기화
        item.dongs = { dongTermSimple: "읍/면/동", dongCode: "" };
        item.dongCode = "";
        return item;
      })
      // 읍면동 데이터 조회
      getDongs(conn, e.value.rgnCode)
      .then(result => {
        setDataSource(dataSource => {
          const item = { ...dataSource };
          item.dongList = result;
          return item;
        })
      })
      .catch(error => {
        console.log("getDongs error = ", error);
      });
      formRenderProps.onChange({ value: e.value.rgnCode });
    };

    return (
      <div>
        <DropDownList
          id="rgn"
          name="rgn"
          data={dataSource.rgnList}
          disabled={!isDeveloper() ? true : false}
          className={styles.allStatusSearchDropdown}
          value={dataState.rgns}
          textField="rgnTermSimple"
          dataItemKey="rgnCode"
          defaultItem={defualtValRgn}
          onChange={handleChange}
        />
      </div>
    );
  };

  // *** 담당 읍면동
  const dongComponent = formRenderProps => {
    if (!formRenderProps.value && isManager) {
      formRenderProps.onChange({ value: userInfo.dongCode });
    }
    const handleChange = e => {
      setDataState(dataState => {
        const item = { ...dataState };
        // 드롭다운 검색조건 변경
        item.dongCode = e.target.value.dongCode;
        item.dongs = e.target.value;
        return item;
      })
      formRenderProps.onChange({ value: e.value.dongCode });
    };

    return (
      <div>
        <DropDownList
          id="dong"
          name="dong"
          data={dataSource.dongList}
          disabled={!isAdmin() ? true : !dataState.rgnCode ? true : false}
          className={styles.allStatusSearchDropdown}
          value={dataState.dongs}
          textField="dongTermSimple"
          dataItemKey="dongCode"
          defaultItem={defualtValDong}
          onChange={handleChange}
        />
      </div>
    );
  };

  // 드롭다운 컨버터 함수
  const converterDong = () => {
    if (dataItem) {
      const rgnData = rgnList.filter(v => v.rgnCode === dataItem.rgnCode)[0];
      const dongData = dongList.filter(v => v.dongCode === dataItem.dongCode)[0];
      if (dongData) {
        setRgn(rgnData);
        setDong(dongData);
      }
    }
  };

  const idInput = formRenderProps => {
    const handleChange = e => {
      formRenderProps.onChange({ value: e.value });
      userId.value = e.value;
      userId.check = false;
    };

    return (
      <Input
        value={userId.value}
        style={{ width: '70%', display: 'inline' }}
        onChange={handleChange}
        placeholder="아이디 입력"
        readOnly={managerInfo.isNew === false ? true : false}></Input>
    );
  };

  //중복확인 버튼 클릭 이벤트
  const duplicateCheckBtnClickEvt = e => {
    e.preventDefault();
    checkDuplicatedId(conn, userId.value)
      .then(response => {
        if (response) {
          kendo.alert('중복된 ID입니다. 다른 ID를 입력해주세요.');
          setUserId({ ...userId, check: false });
        } else {
          if (userId.value) {
            kendo.alert('사용가능한 ID입니다.');
            setUserId({ ...userId, check: true });
          } else {
            kendo.alert('ID를 입력해주세요.');
            setUserId({ ...userId, check: false });
          }
        }
      })
      .catch(error => {});
  };

  useEffect(() => {
    converterDong();
    getDataList();
  }, []);

  return (
    <Dialog title={isNew === false ? '담당자 수정' : '담당자 추가'} onClose={closeEvt} height="600px">
      <div className={styles.installerModalForm}>
        <div className={styles.leftModalItem}>
          <div>ID</div>
          <div>성함</div>
          <div>비밀번호</div>
          <div>비밀번호확인</div>
          <div>담당 시군구</div>
          <div>담당 읍면동</div>
          <div>사무실 연락처</div>
          <div>개인 연락처</div>
        </div>
        <div className={styles.rightModalItem}>
          <Form
            onSubmit={submitData}
            initialValues={dataItem}
            render={formRenderProps => (
              <FormElement>
                <div>
                  {isNew ? (
                    <>
                      <Field name="userId" component={idInput} />
                      <Button style={{ width: '25%' }} onClick={duplicateCheckBtnClickEvt}>
                        중복확인
                      </Button>
                    </>
                  ) : (
                    <Field name="userId" component={Input} placeholder="아이디 입력" readOnly={managerInfo.isNew === false ? true : false} required />
                  )}
                </div>
                <div>
                  <Field name="userTerm" component={Input} placeholder="성함 입력" required />
                </div>
                <div>
                  <Field name="userPassword" component={Input} type="password" placeholder="등록/변경 시 8자 이상 영문,숫자,특수문자 입력" />
                </div>
                <div>
                  <Field name="userPasswordConfirm" component={Input} type="password" placeholder="등록/변경 시 8자 이상 영문,숫자,특수문자 입력" />
                </div>
                <div>
                  <Field name="rgnCode" component={rgnComponent} />
                </div>
                <div>
                  <Field name="dongCode" component={dongComponent} />
                </div>
                <div>
                  <Field name="userPhone" type="tel" component={PhoneInput} placeholder="041-123-5678" validator={telePhoneValidator} />
                </div>
                <div>
                  <Field name="protectorPhone" type="tel" component={Input} placeholder="010-1234-5678" />
                </div>
                <div>
                  <Button onClick={closeEvt}>취소</Button>
                  {isNew ? (
                    <Button type="submit" disabled={!userId.check}>
                      저장
                    </Button>
                  ) : (
                    <Button type="submit" disabled={!formRenderProps.allowSubmit}>
                      저장
                    </Button>
                  )}
                </div>
              </FormElement>
            )}
          />
        </div>
      </div>
    </Dialog>
  );
};
export default ManagerInfo;
